import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import SEO from './SEO';

export default function Layout() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const pageTitle = location.pathname === '/how-it-works' ? 'How It Works - AI Powerball Prediction' : 'AI Powerball Prediction Game';
  const pageDescription = location.pathname === '/how-it-works' 
    ? 'Learn how our AI analyzes lottery patterns for educational purposes. Understand the technology behind pattern recognition in random sequences.'
    : 'AI-powered Powerball number analysis and prediction game. Educational demonstration of pattern recognition in random sequences.';

  // Don't show layout elements on admin page
  if (isAdminPage) {
    return <Outlet />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title={pageTitle}
        description={pageDescription}
        canonicalUrl={`https://www.aipowerballz.com${location.pathname}`}
      />
      <Header />
      
      <div className="flex flex-col relative bg-white">
        <div className="flex-1 min-w-0">          
          {/* Main Content */}
          <div className="w-full max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}